import Fetch, { serializeQueryString } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';
import {
  stockDetailUrl,
  stockPriceUrl,
  stockDiscoveryListUrl,
  stockListByKeywordUrl,
} from './_endpoint';

const fetchGet = (url, { query } = {}) =>
  Fetch.get(`${url}${serializeQueryString(query)}`)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: url });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });

export const getStockDetail = (code) => fetchGet(stockDetailUrl(code));

export const getStockPrice = (code) => fetchGet(stockPriceUrl(code));

/**
 * @param {Object} payload
 * @param {string} payload.group_code
 * @param {number} payload.page
 * @param {number} payload.page_size
 *
 * @returns {Promise<Object>}
 */
export const getStockDiscoveryList = (payload = {}) =>
  fetchGet(stockDiscoveryListUrl, { query: payload });

/**
 * @param {Object} payload
 * @param {string} payload.q search keyword
 * @param {number} payload.page
 * @param {number} payload.page_size
 *
 * @returns {Promise<Object>}
 */
export const getStockByKeyword = (payload = {}) =>
  fetchGet(stockListByKeywordUrl, { query: payload });
